import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Intro from "../../sections/Intro/Intro";
import css from "./Resources.module.css";

const FinanceTracker = () => {
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Track your finances yourself."
        secondary="A free financial tracker for businesses that want to take full ownership of their books."
        button="Let us handle it"
      />

      <h2 style={{ margin: "2rem 0" }}>Two ways to access</h2>

      <div
        className={`${css.checkboxes} ${css.columns} p01`}
        style={{ gap: "1rem", marginBottom: "4rem" }}
      >
        <a
          className="link"
          style={{ maxWidth: "unset" }}
          href="https://docs.google.com/spreadsheets/d/1bKZLREVNX3wLr1QKKRfvTmpNpiqibF-VJGkwZqsaa78/template/preview"
          rel="noopener noreferrer"
          target="_blank"
        >
          Copy Google Sheets template
        </a>
        <a
          className="link"
          style={{ maxWidth: "unset" }}
          href="https://storage.googleapis.com/crystalclearconsulting.appspot.com/Financial%20Tracker.xlsx"
          download
        >
          Download for Excel
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default FinanceTracker;
